/**
 * Love Store Paris — Page Prime VIP (countdown)
 */
(function () {
  'use strict';

  function parseCountdownEnd(value) {
    if (!value) return NaN;
    return Date.parse(String(value).trim().replace(' ', 'T'));
  }

  function initCountdown(root) {
    var countdown = root.querySelector('[data-lsp-countdown]');
    if (!countdown || countdown.dataset.lspCountdownInit === 'true') return;
    countdown.dataset.lspCountdownInit = 'true';

    function tick() {
      var end = parseCountdownEnd(countdown.getAttribute('data-countdown-end'));
      if (isNaN(end)) return;
      var total = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var mins = Math.floor((total % 3600) / 60);
      var secs = total % 60;

      countdown.querySelectorAll('[data-unit]').forEach(function (el) {
        var key = el.getAttribute('data-unit');
        var val = 0;
        if (key === 'days') val = days;
        if (key === 'hours') val = hours;
        if (key === 'minutes') val = mins;
        if (key === 'seconds') val = secs;
        el.textContent = String(val).padStart(2, '0');
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  function initPrimeVipPage(root) {
    if (!root || root.dataset.lspPrimeVipInit === 'true') return;
    root.dataset.lspPrimeVipInit = 'true';
    initCountdown(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lsp-page-prime-vip]').forEach(initPrimeVipPage);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lsp-page-prime-vip]');
    if (root) initPrimeVipPage(root);
  });
})();
